import { useDispatch, useSelector } from 'react-redux';

import type { AppState } from '../../reducer';
import type { Metadata, Series } from '../../shared';
import { Actions } from '../actions';
import { ChartTypes, type SDKType } from '../model';

import { HighAccountUsage } from './HighAccountUsage';

export function HighAccountUsageContainer() {
  const dispatch = useDispatch();
  const highAccountUsage = useSelector((state: AppState) => state.accounts.highAccountUsage);
  const isFetching = useSelector((state: AppState) => state.accounts.highAccountUsageFetchRequest.isFetching);

  const onFetchHighAccountUsage = (usageType: SDKType, dates?: { to: string; from: string }) => {
    dispatch(Actions.fetchHighAccountUsage(usageType, dates));
  };

  return (
    <HighAccountUsage
      isFetching={isFetching}
      series={highAccountUsage.series as Series}
      metadata={(highAccountUsage.metadata as Metadata) || ([] as unknown as Metadata)}
      onFetchHighAccountUsage={onFetchHighAccountUsage}
      chartType={ChartTypes.LINE}
      tooltipText="connection"
    />
  );
}
